import React, { useState } from "react";
import { selectOnboardingPath } from "../../UrlCrud";
import "./onboarding.scss";

// Welcome screen - the first thing a newly-verified user sees. Deliberately
// does NOT expose internal role names (MRO/IMO/Technician/etc) - the user
// picks a plain-language path, and Anike figures out the right role at
// approval time (matching existing role-assignment behaviour).
//
// "Join an existing organisation" is intentionally NOT offered here - no
// self-service invitation-acceptance workflow exists in Anike today (joining
// is always initiated by that organisation's own admin via Manage User ->
// Add User). Adding a real invite-acceptance flow is future work, not
// something to fake here.
export default function WelcomePath({ user, onChoose }) {
    const [choosing, setChoosing] = useState(null);

    const choose = async (onboardingType) => {
        setChoosing(onboardingType);
        try {
            await selectOnboardingPath(onboardingType);
            onChoose(onboardingType);
        } finally {
            setChoosing(null);
        }
    };

    return (
        <div className="onboarding-card">
            <h3 className="font-weight-bolder mb-2">Welcome to Anike{user?.firstName ? `, ${user.firstName}` : ""}.</h3>
            <p className="text-muted mb-8">How will you be using Anike?</p>

            <div className="onboarding-path-options">
                <button
                    type="button"
                    className="onboarding-path-option"
                    disabled={!!choosing}
                    onClick={() => choose("individual")}
                >
                    <div className="onboarding-path-option__title">Use Anike as an individual</div>
                    <div className="onboarding-path-option__desc">
                        You're managing your own assets, on your own - no organisation involved.
                    </div>
                </button>

                <button
                    type="button"
                    className="onboarding-path-option"
                    disabled={!!choosing}
                    onClick={() => choose("organisation")}
                >
                    <div className="onboarding-path-option__title">Set up an organisation</div>
                    <div className="onboarding-path-option__desc">
                        You're setting up Anike for a company, agency, or other organisation.
                    </div>
                </button>
            </div>

            <p className="text-muted mt-8 mb-0" style={{ fontSize: "0.85rem" }}>
                Joining an organisation that already uses Anike? Ask that organisation's
                administrator to add you instead - there's no need to register separately.
            </p>
        </div>
    );
}
